import { render, staticRenderFns } from "./flevel.vue?vue&type=template&id=6dc93470&scoped=true&"
import script from "./flevel.vue?vue&type=script&lang=js&"
export * from "./flevel.vue?vue&type=script&lang=js&"
import style0 from "./flevel.vue?vue&type=style&index=0&id=6dc93470&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc93470",
  null
  
)

export default component.exports